import { Modal } from 'react-bootstrap';
import { ManualForm } from './ManualForm';
import type { CreateManualRequest } from '../../../infrastructure/ManualClient';

interface CreateManualModalProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (data: CreateManualRequest) => void;
  isSubmitting: boolean;
}

export const CreateManualModal = ({ show, onHide, onSubmit, isSubmitting }: CreateManualModalProps) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Create New Manual</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ManualForm onSubmit={onSubmit} isSubmitting={isSubmitting} />
      </Modal.Body>
    </Modal>
  );
};
